import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "../Components/ProtectedRoute";





// Authenticated pages
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Users = lazy(() => import("../pages/users/Users"));
const Facilities = lazy(() => import("../pages/facilities/Facilities"));
const Zones = lazy(() => import("../pages/zones/Zones"));
const Settings = lazy(() => import("../pages/settings/Settings"));
const ProviderManagement= lazy(()=>import("../pages/providers/ProviderManagement"))
const AddProvider = lazy(() => import("../pages/providers/AddProvider"));
const EditProvider = lazy(() => import("../pages/providers/EditProvider"));
const Onboarding= lazy(()=>import("../pages/Onboarding"))
const  UserTypeFlow =lazy(()=>import("../Components/UserTypeFlow"))
const AddFacility = lazy(()=>import("../../src/pages/facilities/AddFacility"))
const AddMmda =lazy(()=>import("../../src/pages/mmda/AddMmda"))
const MmdaManagement = lazy(()=>import ("../pages/mmda/Mmdas"))
const EditFacility =lazy (()=> import ("../pages/facilities/EditFacility"))
const EditMmda =lazy (()=> import ("../pages/mmda/EditMmda"))
const Complaints =lazy (()=> import ("../pages/complaints/Complaints"))
// ADD THIS IMPORT
const ProviderCustomersPage = lazy(() => import("../pages/dashboard/ProviderCustomersPage"));
const Analyticspage= lazy(()=>import("../pages/analytics/AnalyticsPage"))



const authenticatedRoutes = [
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute>
        <Users />
      </ProtectedRoute>
    ),
  },
  {
    path: "/facilities",
    element: (
      <ProtectedRoute>
        <Facilities />
      </ProtectedRoute>
    ),
  },
  {
    path: "/zones",
    element: (
      <ProtectedRoute>
        <Zones />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },

  {
    path:"/provider-management",
    element:(
      <ProtectedRoute>
        <ProviderManagement/>
      </ProtectedRoute>
     
    )
  },
  {
    path:"/provider-management/add",
    element:(
      <ProtectedRoute>
        <AddProvider/>
      </ProtectedRoute>
     
    )
  },
  

  {
    path:"/facility-management/add",
    element:(
      <ProtectedRoute>
        <AddFacility/>
      </ProtectedRoute>
     
    )
  },

  {
    path:"/facility-management",
    element:(
      <ProtectedRoute>
        <Facilities/>
      </ProtectedRoute>
     
    )
  },

   {
    path:"/facility-management/edit/:slug",
    element:(
      <ProtectedRoute>
        <EditFacility/>
      </ProtectedRoute>
     
    )
  },
    {
    path:"/mmda-management",
    element:(
      <ProtectedRoute>
        <MmdaManagement/>
      </ProtectedRoute>
     
    )
  },

  {
    path:"/mmda-management/add",
    element:(
      <ProtectedRoute>
        <AddMmda/>
      </ProtectedRoute>
     
    )
  },
   {
    path:"/mmda-management/edit/:slug",
    element:(
      <ProtectedRoute>
        <EditMmda/>
      </ProtectedRoute>
     
    )
  },
  {
    path:"/provider-management/edit/:slug",
    element:(
      <ProtectedRoute>
        <EditProvider/>
      </ProtectedRoute>
     
    )
  },
  {
    path:"/complaints",
    element:(
      <ProtectedRoute>
        <Complaints/>
      </ProtectedRoute>
     
    )
  },

    {
    path:"/onboarding",
    element:(
      <ProtectedRoute>
        <Onboarding/>
      </ProtectedRoute>
     
    )
  },
  {
    path:"/zones",
    element:(
      <ProtectedRoute>
        <Zones/>
      </ProtectedRoute>
    )
  },

  {
    path:"/user-registration",
    element:<UserTypeFlow/>
  },
  
  // ADD THIS NEW ROUTE FOR PROVIDER CUSTOMERS PAGE
  {
    path:"/provider/:providerSlug/customers",
    element:(
      <ProtectedRoute>
        <ProviderCustomersPage/>
      </ProtectedRoute>
    )
  },
  {
    path:"/reports",
    element:(<ProtectedRoute>
      <Analyticspage/>
    
      </ProtectedRoute>
      )

  
  }
  
  // ADD THIS ROUTE FOR DEMO PURPOSES (if you want a demo route)
  // {
  //   path:"/provider/demo/:providerId/customers",
  //   element:(
  //     <ProtectedRoute>
  //       <ProviderCustomersPage/>
  //     </ProtectedRoute>
  //   )
  // }
];

export default authenticatedRoutes;